export const COURSE_LIST_URL = "/students/courses?page_size=20";

export const COURSE_DETAILS_URL = "/students/courses/";

export const CLASS_JOIN_URL = (classId) =>
  `/students/classes/${classId}/join?confirm=true`;

export const CHECKOUT_URL = (id) => `/checkout/${id}`;

export const STUDENT_URLS = {
  PROFILE: "/students/me",
  LOGOUT: "/students/logout",

  COURSE_LIST: "/students/courses?page_size=20",
  SUBSCRIBED_COURSE_LIST: "/students/courses?subscribed=true&page_size=20",
  COURSE: (courseId) => `/students/courses/${courseId}`,

  CLASS_LIST: "/students/classes",
  CLASS_JOIN: (classId) => `/students/classes/${classId}/join?confirm=true`,
};

export const TEACHER_URLS = {
  PROFILE: "/teachers/me",
  REGISTER: "/teachers/register",

  COURSE_LIST: "/teachers/courses",
  COURSE: (courseId) => `/teachers/courses/${courseId}`,

  CLASS_LIST: "/teachers/classes",
  CLASS_JOIN: (classId) => `/teachers/classes/${classId}/join`,
  CLASS: (classId) => `/teachers/classes/${classId}`,
};
